import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Button from '../Button';
import ProductItems from '../ProductSpotlight/ProductItems';
import css from './ToggleProductCategories.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ToggleProductCategories = function ToggleProductCategories(_ref) {
  var fabric = _ref.fabric,
      productItemsMen = _ref.productItemsMen,
      productItemsWomen = _ref.productItemsWomen,
      title = _ref.title;

  var _useState = useState('women'),
      _useState2 = _slicedToArray(_useState, 2),
      gender = _useState2[0],
      setGender = _useState2[1];

  var isWomenActive = function isWomenActive(item) {
    return item === 'women';
  };

  var activeWomen = isWomenActive(gender);
  var mensCatClass = cc([css.category, _defineProperty({}, css.active, !activeWomen)]);
  var mensProdClass = cc([css.productItems, _defineProperty({}, css.active, !activeWomen)]);
  var womensCatClass = cc([css.category, _defineProperty({}, css.active, activeWomen)]);
  var womensProdClass = cc([css.productItems, _defineProperty({}, css.active, activeWomen)]);

  var onClick = function onClick(e) {
    var target = e.target;
    var nextGender = target.innerText.toLowerCase();
    return setGender(nextGender);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h2", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: css.toggler,
      children: [/*#__PURE__*/_jsx(Button, {
        className: womensCatClass,
        gray: !isWomenActive(gender),
        medium: true,
        onClick: onClick,
        children: "women"
      }), /*#__PURE__*/_jsx(Button, {
        className: mensCatClass,
        medium: true,
        onClick: onClick,
        gray: isWomenActive(gender),
        children: "men"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: womensProdClass,
      children: /*#__PURE__*/_jsx(ProductItems, {
        fabric: fabric,
        items: productItemsWomen,
        title: title
      })
    }), /*#__PURE__*/_jsx("div", {
      className: mensProdClass,
      children: /*#__PURE__*/_jsx(ProductItems, {
        fabric: fabric,
        items: productItemsMen,
        title: title
      })
    })]
  });
};

var productItemPropTypes = {
  cta: PropTypes.string.isRequired,
  fabric: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  image: PropTypes.string.isRequired,
  imageLeft: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
ToggleProductCategories.propTypes = {
  fabric: PropTypes.string.isRequired,
  productItemsMen: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, productItemPropTypes)).isRequired).isRequired,
  productItemsWomen: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, productItemPropTypes)).isRequired).isRequired,
  title: PropTypes.string.isRequired
};
export default ToggleProductCategories;